// Curated palette presets for the embeddable widget. Stored as `theme` on the agent.
// Each preset has a primary (gradients, buttons, user message bubbles), an "ink" color
// for text-on-primary, and an accent for the voice tab radial glow.
//
// To add a new preset: just push another entry — server stores any string and the UI
// falls back to "blue" if the key is unknown.

export const WIDGET_THEMES = {
  blue:   { name: "Ocean",     primary: "#0044FF", primaryHover: "#0033CC", ink: "#FFFFFF", accent: "rgba(0,68,255,0.25)" },
  green:  { name: "Forest",    primary: "#10B981", primaryHover: "#0E9F6E", ink: "#FFFFFF", accent: "rgba(16,185,129,0.25)" },
  purple: { name: "Royal",     primary: "#7C3AED", primaryHover: "#6D28D9", ink: "#FFFFFF", accent: "rgba(124,58,237,0.25)" },
  red:    { name: "Crimson",   primary: "#EF4444", primaryHover: "#DC2626", ink: "#FFFFFF", accent: "rgba(239,68,68,0.25)" },
  orange: { name: "Sunset",    primary: "#F97316", primaryHover: "#EA580C", ink: "#FFFFFF", accent: "rgba(249,115,22,0.25)" },
  pink:   { name: "Bloom",     primary: "#EC4899", primaryHover: "#DB2777", ink: "#FFFFFF", accent: "rgba(236,72,153,0.25)" },
  slate:  { name: "Slate",     primary: "#475569", primaryHover: "#334155", ink: "#FFFFFF", accent: "rgba(71,85,105,0.25)" },
  black:  { name: "Onyx",      primary: "#0F1115", primaryHover: "#000000", ink: "#FFFFFF", accent: "rgba(15,17,21,0.35)" },
};

export const getTheme = (key) => WIDGET_THEMES[key] || WIDGET_THEMES.blue;

export const THEME_KEYS = Object.keys(WIDGET_THEMES);
